import { Drawer as MuiDrawer } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { useSelector } from 'react-redux';

import { DRAWER_WIDTH } from '../../../store/constants';
import DrawerContent from './DrawerContent';

const COLLAPSED_WIDTH = 56

const openedMixin = (theme) => ({
    width: DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
})

const closedMixin = (theme) => ({
    width: COLLAPSED_WIDTH,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
})

const StyledDrawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    width: open ? DRAWER_WIDTH : COLLAPSED_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open ? openedMixin(theme) : closedMixin(theme)),
    '& .MuiDrawer-paper': {
        top: 64,
        height: `calc(100vh - 64px)`,
        position: 'fixed',
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        ...(!open ? closedMixin(theme) : openedMixin(theme)),
    },
}))

const PermanentDrawer = ({ selectedKey }) => {
    const isOpen = useSelector((state) => state.drawer.isOpen)

    return (
        <StyledDrawer
            variant="permanent"
            open={isOpen}
            sx={{
                display: { xs: 'none', md: 'block' },
                '& .MuiDrawer-paper': {
                    zIndex: (theme) => theme.zIndex.drawer,
                }
            }}
        >
            <DrawerContent selectedKey={selectedKey} />
        </StyledDrawer>
    )
}

PermanentDrawer.propTypes = {
    selectedKey: PropTypes.string.isRequired,
}

export default PermanentDrawer